import { render, staticRenderFns } from "./NbCardForm.vue?vue&type=template&id=450a8a8c&scoped=true&"
import script from "./NbCardForm.vue?vue&type=script&lang=js&"
export * from "./NbCardForm.vue?vue&type=script&lang=js&"
import style0 from "./NbCardForm.vue?vue&type=style&index=0&id=450a8a8c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450a8a8c",
  null
  
)

export default component.exports